













































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { LanguageDto, FeedbackDto } from "@/server/app.dtos";
import {
  GetFeedbacksDtosIncludeOptions,
	GetSingleFeedbackDtoQuery
} from "@/server/app.queries";
import { ISideMenuItem } from "@/models/menus/abstract/isidemenu";
import ConfigsService from "@/services/api/configs.service";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import { FeedbackService } from "@/services/api/feedback.service";
import SendAlertsButtonComponent from '@/components/buttons/SendAlerts.vue';
@Component({
  components: {
    SendAlertsButton: SendAlertsButtonComponent
  }
})
export default class FeedbackDetailSharedPage extends Vue {
  feedbackService: FeedbackService = new FeedbackService();
  configsService: ConfigsService = new ConfigsService();
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  feedback: FeedbackDto | null = null;
  menus: ISideMenuItem[] = [
    {
      icon: "las la-cog",
      title: "Dashboard",
      url: "dashboard"
    },
    {
      icon: "las la-cog",
      title: "Questões",
      url: "questions"
    },
    {
      icon: "las la-cog",
      title: "Grupos de Questões",
      url: "questiongroups"
    },
    {
      icon: "las la-cog",
      title: "Utilizadores",
      url: "users"
    },
    {
      icon: "las la-cog",
      title: "Comentários",
      url: "comments"
    }
  ];
  actionMenu: boolean = false;
  isLoading: boolean = false;
  description: string ="";

  get currentPath(): string {
    return this.$route.path;
  }

  @Watch("$route")
  onRouteChange() {
    this.Load();
  }

  async created() {
    await this.Load();
  }

  async Load() {
    const query = new GetSingleFeedbackDtoQuery();
    query.idFeedback = parseInt(this.$route.params.id);
    query.includes = new GetFeedbacksDtosIncludeOptions();
    query.includes.user = true;
    query.includes.feedbackType = true;
    query.includes.feedbackQuestionGroup = true;
    query.includes.appGroupVsFeedback = true;
    await this.feedbackService
      .GetSingle(query)
      .then((result: FeedbackDto) => {
        this.feedback = result;
      })
      .catch(() => (this.feedback = null));

    if(this.feedback && this.feedback.description){
      const regex =  /(<([^>]+)>)/ig;
      this.description = this.feedback.description.replace(regex, "")
    }
  }

  async deleteFeedback() {
    if (this.isLoading) {
      return;
    }

    if (this.feedback) {
      await this.feedbackService
        .DeleteById(this.feedback.idFeedback || 0)
        .catch((error: any) => NotificationServiceBus.showError(error))
        .then(() => this.$router.push("/feedback/"));
    }
  }
}
